export default __webpack_public_path__ + "static/media/illustration-study-2-n-m@3x.fbae4fde.webp";